export default "__VITE_ASSET__3cef4450__"